<template>
  <div class="container">
    <div class="banner">
      <company-logo class="logo" />
      <div class="company-title">
        {{ COMPANY_TITLE }}
      </div>
    </div>
    <div class="logo-mobile">
      <company-logo-mobile />
    </div>
    <div class="form">
      <router-view />
    </div>
  </div>
</template>

<script>
import { COMPANY_TITLE } from '@/messages/notes'
import CompanyLogo from '@/components/icons/CompanyLogo.vue'
import CompanyLogoMobile from '@/components/icons/CompanyLogoMobile.vue'

export default {
  components: {
    CompanyLogoMobile,
    CompanyLogo,
  },
  data() {
    return {
      COMPANY_TITLE: COMPANY_TITLE,
    }
  },
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  height: 100%;
  @media only screen and (max-width: $tablet-size) {
    flex-direction: column;
    padding: 16px 20px;
  }
  .banner {
    display: flex;
    position: relative;
    width: 33%;
    background-image: url(../assets/images/signUpBanner.png);
    background-size: cover;
    height: 100vh;

    @media only screen and (max-width: $tablet-size) {
      display: none;
    }

    .logo {
      position: absolute;
      top: 40px;
      left: 40px;
    }

    .company-title {
      @include h3;
      color: #ffffff;
      width: 400px;
      height: 124px;
      padding: 28px 24px 28px 28px;
      border: 2px solid rgba(255, 255, 255, 0.4);
      background: rgba(255, 255, 255, 0.2);
      margin: 112px auto;
    }
  }
  .logo-mobile {
    display: none;

    @media only screen and (max-width: $tablet-size) {
      display: block;
    }
  }
  .form {
    display: flex;
    margin: auto;
    @media only screen and (max-width: $tablet-size) {
      width: 100%;
    }
  }
}
</style>
